import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index/index'
import mallIndex from '@/pages/mall/mallIndex'
import meIndex from '@/pages/me/meIndex'
import setPayPwd from '@/pages/me/setPayPwd'
import forgetPayPwd from '@/pages/me/forgetPayPwd'
import myVipCard from '@/pages/me/myVipCard'
import addVipCard from '@/pages/me/addVipCard'
import cityList from '@/pages/city/cityList'
import orderList from '@/pages/order/orderList'
import orderDetail from '@/pages/order/orderDetail'
import preAliPay from '@/pages/order/preAliPay'
import logup from '@/pages/login/logup'
import enterCode from '@/pages/login/enterCode'
import phoneLogin from '@/pages/login/phoneLogin'
import movieIndex from '@/pages/movie/movieIndex'
import movieDetail from '@/pages/movie/movieDetail'
import cinemaList from '@/pages/movie/cinemaList'
import cinemaMovieList from '@/pages/movie/cinemaMovieList'
import selectSeat from '@/pages/movie/selectSeat'
import cinemaLocation from '@/pages/movie/cinemaLocation'
import confirmOrder from '@/pages/order/confirmOrder'
import orderInfo from '@/pages/movie/orderInfo'
import searchCinema from '@/pages/search/searchCinema'
import districtFilter from '@/pages/search/districtFilter'
import productDetail from '@/pages/mall/productDetail'
import cart from '@/pages/mall/cart'
import mallOrderInfo from '@/pages/mall/mallOrderInfo'
import birthdayCard from '@/pages/mall/birthdayCard'
import newAddress from '@/pages/address/newAddress'
import addressList from '@/pages/address/addressList'
import viewLocation from '@/pages/address/viewLocation'
import couponList from '@/pages/coupon/couponList'
import addCoupon from '@/pages/coupon/addCoupon'
import selectCoupon from '@/pages/coupon/selectCoupon'
import errPage from '@/pages/err/errPage'
import showIndex from '@/pages/show/showIndex'
import showDetail from '@/pages/show/showDetail'
import lifeIndex from '@/pages/life/lifeIndex'
import lifeCouponDetail from '@/pages/life/lifeCouponDetail'
import kfcSelectDiner from '@/pages/kfc/kfcSelectDiner'
import kfcIndex from '@/pages/kfc/kfcIndex'
import kfcMenu from '@/pages/kfc/kfcMenu'
import kfcCombo from '@/pages/kfc/kfcCombo'
import kfcProductDetail from '@/pages/kfc/kfcProductDetail'
import kfcCheckout from '@/pages/kfc/kfcCheckout'
import xbkIndex from '@/pages/xbk/xbkIndex'
import xbkMenu from '@/pages/xbk/xbkMenu'
import xbkCheckout from '@/pages/xbk/xbkCheckout'
import xbkVoucher from '@/pages/xbk/xbkVoucher'
import xbkVoucherDetail from '@/pages/xbk/xbkVoucherDetail'
import encrypt from '@/pages/encrypt/encrypt'


Vue.use(Router)

export default new Router({
  routes: [
    // 推荐首页
    {
      path: '/index',
      name: 'index',
      component: index
    },
    // 城市列表
    {
      path: '/cityList',
      name: 'cityList',
      component: cityList
    },
    // 我的
    {
      path: '/meIndex',
      name: 'meIndex',
      component: meIndex
    },
    // 设置支付密码
    {
      path: '/setPayPwd',
      name: 'setPayPwd',
      component: setPayPwd,
      meta: {
        requireAuth: true, //需要登录
      }
    },
    // 忘记（重置）支付密码
    {
      path: '/forgetPayPwd',
      name: 'forgetPayPwd',
      component: forgetPayPwd
    },
    // 我的贵宾卡
    {
      path: '/myVipCard',
      name: 'myVipCard',
      component: myVipCard
    },
    // 我的贵宾卡
    {
      path: '/addVipCard',
      name: 'addVipCard',
      component: addVipCard
    },
    // 订单列表
    {
      path: '/orderList',
      name: 'orderList',
      component: orderList,
      meta: {
        requireAuth: true, //需要登录
      }
    },
    // 订单详情
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: orderDetail,
      meta: {
        requireAuth: true, //需要登录
      }
    },
    // 支付宝预支付页面
    {
      path: '/preAliPay',
      name: 'preAliPay',
      component: preAliPay
    },
    // 商城首页
    {
      path: '/mallIndex',
      name: 'mallIndex',
      component: mallIndex,
      meta: {
        keepAlive: true
      }
    },
    // 注册/登录
    {
      path: '/logup',
      name: 'logup',
      component: logup,
      meta: {
        title: "注册/登录",
      }
    },
    // 输入验证码
    {
      path: '/enterCode',
      name: 'enterCode',
      component: enterCode
    },
     // 手机登陆
     {
      path: '/phoneLogin',
      name: 'phoneLogin',
      component: phoneLogin
    },
    // 电影首页
    {
      path: '/',
      name: 'movieIndex',
      component: movieIndex,
      meta: {
        keepAlive: true,
        title: "电影在线选座购票"
      }
    },
    // 电影详情
    {
      path: '/movieDetail',
      name: 'movieDetail',
      component: movieDetail,
      meta: {
        title: "电影在线选座购票"
      }
    },
    // 影院列表
    {
      path: '/cinemaList',
      name: 'cinemaList',
      component: cinemaList,
      meta: {
        title: "电影在线选座购票"
      }
    },
    // 影院内电影列表
    {
      path: '/cinemaMovieList',
      name: 'cinemaMovieList',
      component: cinemaMovieList,
      meta: {
        title: "电影在线选座购票"
      }
    },
    // 选择座位
    {
      path: '/selectSeat',
      name: 'selectSeat',
      component: selectSeat,
      meta: {
        requireAuth: true, //需要登录
        title: "电影在线选座购票"
      }
    },
    // 电影院定位
    {
      path: '/cinemaLocation',
      name: 'cinemaLocation',
      component: cinemaLocation,
      meta: {
        requireAuth: false, //需要登录
      }
    },
    // 确认订单
    {
      path: '/confirmOrder',
      name: 'confirmOrder',
      component: confirmOrder,
      meta: {
        requireAuth: true, //需要登录
        title: "确认订单"
      }
    },
    // 订单信息
    {
      path: '/orderInfo',
      name: 'orderInfo',
      component: orderInfo,
      meta: {
        requireAuth: true, //需要登录
      }
    },
    // 搜索影院
    {
      path: '/searchCinema',
      name: 'searchCinema',
      component: searchCinema
    },
    // 区域筛选
    {
      path: '/districtFilter',
      name: 'districtFilter',
      component: districtFilter
    },
    // 商品详情
    {
      path: '/productDetail',
      name: 'productDetail',
      component: productDetail
    },
    // 购物车
    {
      path: '/cart',
      name: 'cart',
      component: cart,
      meta: {
        requireAuth: true, //需要登录
      }
    },
    // 商城订单信息
    {
      path: '/mallOrderInfo',
      name: 'mallOrderInfo',
      component: mallOrderInfo,
      meta: {
        requireAuth: true, //需要登录
        keepAlive: true
      }
    },
    // 填写生日牌信息
    {
      path: '/birthdayCard',
      name: 'birthdayCard',
      component: birthdayCard
    },
    {
      path: '/newAddress',
      name: 'newAddress',
      component: newAddress
    },
    {
      path: '/addressList',
      name: 'addressList',
      component: addressList
    },
    {
      path: '/viewLocation',
      name: 'viewLocation',
      component: viewLocation
    },
    // 优惠券列表
    {
      path: '/couponList',
      name: 'couponList',
      component: couponList,
      meta: {
        requireAuth: true, //需要登录
        keepAlive: true
      }
    },
    // 添加优惠券
    {
      path: '/addCoupon',
      name: 'addCoupon',
      component: addCoupon,
      meta: {
        requireAuth: true, //需要登录
      }
    },
    {
      path: '/selectCoupon',
      name: 'selectCoupon',
      component: selectCoupon,
      meta: {
        requireAuth: true, //需要登录
      }
    },
    // 错误页面
    {
      path: '/errPage',
      name: 'errPage',
      component: errPage,
      meta: {
        requireAuth: false, //需要登录
      }
    },
    // 演出首页
    {
      path: '/showIndex',
      name: 'showIndex',
      component: showIndex,
      meta: {
        keepAlive: true
      }
    },
    // 演出详情
    {
      path: '/showDetail',
      name: 'showDetail',
      component: showDetail
    },
    // 生活卡券首页
    {
      path: '/lifeIndex',
      name: 'lifeIndex',
      component: lifeIndex,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/lifeCouponDetail',
      name: 'lifeCouponDetail',
      component: lifeCouponDetail,
      meta: {
        requireAuth: true, //需要登录
      }
    },
    {
      path: '/kfcSelectDiner',
      name: 'kfcSelectDiner',
      component: kfcSelectDiner,
      meta: {
        keepAlive: true,
        title: "肯德基点餐"
      }
    },
    {
      path: '/kfcIndex',
      name: 'kfcIndex',
      component: kfcIndex,
      meta: {
        title: "肯德基点餐"
      }
    },
    {
      path: '/kfcMenu',
      name: 'kfcMenu',
      component: kfcMenu,
      meta: {
        keepAlive: true,
        title: "肯德基点餐"
      }
    },
    {
      path: '/kfcCombo',
      name: 'kfcCombo',
      component: kfcCombo,
      meta: {
        title: "肯德基点餐"
      }
    },
    {
      path: '/kfcProductDetail',
      name: 'kfcProductDetail',
      component: kfcProductDetail,
      meta: {
        title: "肯德基点餐"
      }
    },
    {
      path: '/kfcCheckout',
      name: 'kfcCheckout',
      component: kfcCheckout,
      meta: {
        requireAuth: true, //需要登录
        title: "肯德基点餐",
        isKfc: true,
        keepAlive: true
      }
    },
    {
      path: '/xbkIndex',
      name: 'xbkIndex',
      component: xbkIndex,
      meta: {
        title: "星巴克咖啡"
      }
    },
    {
      path: '/xbkMenu',
      name: 'xbkMenu',
      component: xbkMenu,
      meta: {
        title: "星巴克咖啡",
        keepAlive: true
      }
    },
    {
      path: '/xbkCheckout',
      name: 'xbkCheckout',
      component: xbkCheckout,
      meta: {
        title: "星巴克咖啡",
        requireAuth: true, //需要登录
        keepAlive: true
      }
    },
    {
      path: '/xbkVoucher',
      name: 'xbkVoucher',
      component: xbkVoucher,
      meta: {
        title: "星巴克咖啡"
      }
    },
    {
      path: '/xbkVoucherDetail',
      name: 'xbkVoucherDetail',
      component: xbkVoucherDetail,
      meta: {
        title: "星巴克咖啡",
        requireAuth: true, //需要登录
      }
    },
    {
      path: '/encrypt',
      name: 'encrypt',
      component: encrypt
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js